import { ExternalLink } from "@octopusdeploy/design-system-components";
import * as React from "react";
import { toKnownLicenseUsageName } from "~/areas/configuration/components/LicenseUsage/KnownLicenseUsageName";
export function getLicenseUsageContextualHelp(licenseUsageName: string) {
    switch (toKnownLicenseUsageName(licenseUsageName)) {
        case "machines":
            return (<>
                    A machine is a Windows, Linux, or MacOS application host registered as a deployment target or worker.
                    <ExternalLink href="how-to-count-ptm-machines">Learn how Octopus counts machines.</ExternalLink>
                </>);
        default:
            return undefined;
    }
}
